import { useCallback, useState } from 'react'

import { useSelector } from 'react-redux'
import { faSearch, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'

import IconButton from '../../../Components/antd/Buttons/IconButton'
import SearchField from '../../../Components/antd/Inputs/SearchField'
import { getAllStudents, SerializationContexts } from '../../../utils/api/student'
import { selectUser } from '../../../reducers/UserReducer'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { ColorsPalette } from '../../../config/colors'
import { onError } from '../../../utils/apiHelper'

const StudentSearchBar = ({ className, containerStyle, fieldStyle = {}, showNotFound, onSubmit }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [searchValue, setSearchValue] = useState('')
  const [isError, setIsError] = useState(false)

  const errorStyle = showNotFound && isError ? { border: '1px solid red', borderRadius: '5px' } : {}

  const handleChange = value => {
    setSearchValue(value)

    if (value.length === 0) {
      setIsError(false)
    }
  }

  const handleSearch = useCallback(e => {
    e.preventDefault()

    getAllStudents(user, {
      filters: {
        email: searchValue
      },
      contexts: [SerializationContexts.SCHOOL, SerializationContexts.SECTION, SerializationContexts.NISS]
    }).then(response => {
      if (response.meta) {
        setIsError(showNotFound && response.meta?.pages?.total === 0)
      }

      onSubmit(response, searchValue)
    }).catch(reason => {
      console.error(reason)

      onError(reason)
    })
  }, [searchValue])

  return (
    <div style={containerStyle} className={className}>
      <IconLabel
        icon={faUserGraduate}
        text={t('search_student.icon_label')}
        color={ColorsPalette.BLUE_ICON}
        fontSize={FontSizes.REGULAR}
        padding={null}
      />

      <SearchField
        placeholder='search_student.search_field.label'
        value={searchValue}
        autoFocus
        width='100%'
        fieldStyle={{ ...fieldStyle, ...errorStyle }}
        onChange={handleChange}
        onPressEnter={handleSearch}
      />
      {isError && (
        <span className='text-color-red ml-4'>
          {t('search_student.search_field.not_found')}
        </span>
      )}

      <IconButton
        disabled={searchValue.length === 0}
        className='mt-12 mb-4'
        icon={faSearch}
        text={t('filter.search')}
        onClick={handleSearch}
      />
    </div>
  )
}

export default StudentSearchBar
